<h1 class="title" [innerHTML]="title"></h1>
<mat-divider></mat-divider>
